import BasePopupHandler from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import { IUIButtonData } from '../../../Prototype/UI/BaseElements/UIButton';
import { TextAlignment } from '../../../Prototype/UI/TextAlignment';
import { Native } from '@sgorg/mobile-dev-tools';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { PopupID } from '../../../State/UI/PopupID';

export default class GDPRMenuHandler extends BasePopupHandler {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.GDPR_POPUP, uiSystem);
    }

    public createPopup(params?: any) {
        this.submitBtnParams.text.textLocalizationKey = 'Accept';
        this.submitBtnParams.text.style = this.getSubmitStyle();
        this.submitBtnParams.onClick = () =>
            PlayerActions.agreeWithTerms();

        super.createPopup({
            buttons: [
                this.submitBtnParams,
                this.termsOfService,
                this.privacyPolicy,
            ],
            title: Game.locale.getText('Important'),
        });

        this.createMainInfo();
    }

    private createMainInfo(): void {
        const text: GameObject<PIXI.Container> = UIItem.createText(
            this.textParams
        );
        this.background.addChild(text);
    }

    protected textParams: ITextData = {
        name: 'gdpr_text',
        textLocalizationKey: 'GDPRBody',
        layout: {
            anchors: [0.5, 0.35, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '32px',
        },
        bounds: [650, 400],
        wordWrap: true,
        wordWrapWidth: 650
    };

    protected termsOfService: IUIButtonData = {
        name: 'popup_submit_button',
        text: {
            name: 'terms_txt',
            layout: {
                anchors: [0.5, 0.8, 0.1, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            textLocalizationKey: 'TermsOfService',
            style: {
                fontFamily: 'FrancoisOne',
                strokeThickness: 5,
                fill: 'white',
                stroke: '#8c0154',
                lineJoin: 'miter',
                miterLimit: 2,
                align: 'center',
                fontSize: '34px',
            },
            align: TextAlignment.CENTER,
            bounds: [220, 130],
        },
        buttonMode: true,
        onClick: () => {
            Native.main.openUrl('https://www.softgames.com/terms-of-use/');
        },
    };

    protected privacyPolicy: IUIButtonData = {
        name: 'popup_submit_button',
        text: {
            name: 'terms_txt',
            layout: {
                anchors: [0.5, 0.8, 0.9, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            textLocalizationKey: 'PrivacyPolicy',
            style: {
                fontFamily: 'FrancoisOne',
                strokeThickness: 5,
                fill: 'white',
                stroke: '#8c0154',
                lineJoin: 'miter',
                miterLimit: 2,
                align: 'center',
                fontSize: '34px',
            },
            align: TextAlignment.CENTER,
            bounds: [220, 130],
        },
        buttonMode: true,
        onClick: () => {
            Native.main.openUrl('https://www.softgames.com/privacy/');
        },
    };

    private getSubmitStyle() {
        return {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '50px',
            stroke: '#187630',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        };
    }

    protected titleParams: ITextData = {
        name: 'popup_title',
        text: 'Title',
        style: {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '45px',
            stroke: '#ab3143',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        },
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.45],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        bounds: [460, 240],
    };
}
